import {
  Alert,
  Box,
  colors,
  Divider,
  Grid,
  Modal,
  Typography,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { IListInscricoesActive } from "interfaces/inscricoes";
import FormField from "layouts/pages/users/new-user/components/FormField";
import { Form, Formik } from "formik";
import form from "../schemas/forms";
import { initialValuesCortesia } from "../schemas/initialValues";
import { validationCortesia } from "../schemas/validations";

const {
  formField: { observacao },
} = form;

interface Props {
  open: boolean;
  handleOpen: () => void;
  handleSubmit: (values: any) => void;
  inscricao: IListInscricoesActive;
}

export default function ModalCortesia({
  open,
  handleOpen,
  handleSubmit,
  inscricao,
}: Props) {
  const NUM_ATLETAS_INSCRITOS = inscricao.inscritos.length || 0;

  // Salvar cortesia da inscrição
  const handleSaveCortesia = async (values: any) => {
    handleSubmit(values);
  };

  return (
    <Modal
      open={open}
      onClose={handleOpen}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: { xs: "95%", sm: 400, md: 800 },
          p: 3,
          position: "relative",
        }}
      >
        <MDBox>
          <MDTypography variant="h5">
            Definir incrição como cortesia
          </MDTypography>
          <MDTypography variant="subtitle2" color="text">
            {inscricao.evento.titulo}
          </MDTypography>
        </MDBox>

        <Divider />

        {/* DADOS DO ATLETA */}
        <Grid container spacing={3}>
          <Grid item xs={12} sm={9}>
            <MDBox>
              <MDTypography variant="body2" color="info" fontWeight="bold">
                {inscricao.nomeResponsavel}
              </MDTypography>
              <MDTypography variant="body2" color="text">
                CPF: {inscricao.cpfResponsavel}
              </MDTypography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={3}>
            <MDBox>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Número de Inscrição
              </MDTypography>
              <MDTypography
                variant="body2"
                color="text"
                bgcolor=""
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
              >
                #{inscricao.numeroInscricao}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
        <Alert variant="standard" severity="warning" sx={{ mt: 2 }}>
          {`🏃‍♂️‍➡️ Inscrição contém ${NUM_ATLETAS_INSCRITOS} ${
            NUM_ATLETAS_INSCRITOS > 1 ? "atletas inscritos" : "atleta inscrito"
          }`}
        </Alert>
        <Divider />

        {/* Camiseta */}
        <MDBox mt={2}>
          <Formik
            initialValues={initialValuesCortesia}
            validationSchema={validationCortesia}
            onSubmit={(values) => handleSaveCortesia(values)}
          >
            {({ values, handleChange }) => {
              return (
                <Form id="form-cortesia">
                  <FormField
                    required
                    multiline
                    rows={4}
                    type={observacao.type}
                    name={observacao.name}
                    label={observacao.label}
                    variant="outlined"
                    value={values.observacao}
                    onChange={handleChange}
                  />
                  {/* AÇÕES */}
                  <Typography
                    variant="body2"
                    color={colors.grey[500]}
                    sx={{ mt: 1 }}
                  >
                    {`Ao aplicar a cortesia, ela será concedida exclusivamente a ${NUM_ATLETAS_INSCRITOS}  ${
                      NUM_ATLETAS_INSCRITOS > 1
                        ? "atletas inscritos."
                        : "atleta inscrito."
                    }`}
                  </Typography>
                  <Divider />
                  <MDBox
                    display="flex"
                    flexDirection="row"
                    gap={1}
                    justifyContent="flex-end"
                  >
                    <MDButton variant="gradient" color="info" type="submit">
                      Definir cortesia
                    </MDButton>
                    <MDButton
                      variant="gradient"
                      color="light"
                      onClick={handleOpen}
                    >
                      Cancelar
                    </MDButton>
                  </MDBox>
                </Form>
              );
            }}
          </Formik>
        </MDBox>
      </Box>
    </Modal>
  );
}

const style = {
  position: "absolute" as "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
